// extracted by mini-css-extract-plugin
export var headerXL = "Footer-module--headerXL--2gyVt";
export var headerL = "Footer-module--headerL--Bokec";
export var headerM = "Footer-module--headerM--3Tgtc";
export var headerS = "Footer-module--headerS--1qe_V";
export var headerXS = "Footer-module--headerXS--3D-Ub";
export var blogHeaderXL = "Footer-module--blogHeaderXL--37X68";
export var blogHeaderL = "Footer-module--blogHeaderL--11diI";
export var blogHeaderM = "Footer-module--blogHeaderM--2zitV";
export var blogHeaderS = "Footer-module--blogHeaderS--2B5yC";
export var blogHeaderXS = "Footer-module--blogHeaderXS--2UTt2";
export var headerPreamble = "Footer-module--headerPreamble--1Lj9U";
export var preHeader = "Footer-module--preHeader--3ST4d";
export var textNormal = "Footer-module--textNormal--xKKz4";
export var textSmall = "Footer-module--textSmall--Qaftv";
export var textSmallAlternate = "Footer-module--textSmallAlternate--1jsvK";
export var legend = "Footer-module--legend--3J9pX";
export var caption = "Footer-module--caption--dvjUC";
export var gradientBackground = "Footer-module--gradientBackground--DlgM2";
export var ellipsis = "Footer-module--ellipsis--2w664";
export var globalContainer = "Footer-module--globalContainer--3c8Bs";
export var maxWidth = "Footer-module--maxWidth--35ZYm";
export var clipBottom = "Footer-module--clipBottom--L6NPz";
export var clipTopBottom = "Footer-module--clipTopBottom--RSZ3t";
export var footer = "Footer-module--footer--2sShv";
export var footerContainer = "Footer-module--footerContainer--2vxD0";
export var navContainer = "Footer-module--navContainer--1uv42";
export var footerHeader = "Footer-module--footerHeader--UwAoq";
export var footerLogo = "Footer-module--footerLogo--x8rfz";
export var footerMenu = "Footer-module--footerMenu--2qYxZ";
export var divider = "Footer-module--divider--3KQl3";
export var miscContainer = "Footer-module--miscContainer--35Wur";
export var ch2 = "Footer-module--ch2--2YjQV";
export var ch2Container = "Footer-module--ch2-container--1r80v";